import { Drive } from "./Drive";
import { Cable } from "./Cable";
import { MFGDBColumn } from "./MFGDBColumn";

export class MFG{
  public constructor() {
    this.Name = "";
    this.DisplayName = "";
    this.Drives = [];
    this.Cables = [];
    this.RowPointer = "";
    this.MotorCode = "";
    this.MFGDBColumns = [];
    this.ResourceURL = "";
    this.RowPointer = "";
    this.CreateDate = new Date();
    this.RecordDate = new Date();
    this.CreatedBy = "";
    this.UpdatedBy = "";
  }

  
  public Name: string;
  public DisplayName: string;
  public ResourceURL: string;
  public MotorCode: string;
  public Drives: Drive[];
  public Cables: Cable[];
  public MFGDBColumns: MFGDBColumn[];
  //Syteline fields
  public RowPointer: string;
  public CreateDate: Date;
  public RecordDate: Date;
  public CreatedBy: string;
  public UpdatedBy: string;
}
